/**
 * Ссылка уведомления (`notification.link` с бэка) → маршрут приложения, или null — не кликабельно.
 * Бэк ЭДО шлёт `/edo/requests/:id`, а карточка документа во фронте — `/processes/:id`. Только
 * внутренние пути: начинаются с одного `/` (как safeNext в AuthGate), без вложенных сегментов.
 */
export function notifHref(link: string | null | undefined): string | null {
  if (!link || !link.startsWith('/') || link.startsWith('//')) return null
  const edo = /^\/edo\/requests\/([^/?#]+)$/.exec(link)
  if (edo) return `/processes/${edo[1]}`
  if (/^\/payments\/[^/?#]+$/.test(link)) return link
  return null
}
